import React, { useRef } from "react";
import Navbar from "../components/Navbar";
import ContactImg from "../assets/img/maxrmbg.webp";
import { Link } from "react-router-dom";
import Logo from "../assets/img/logo-1.png";
import emailjs from "@emailjs/browser";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_55y55x4",
        "template_7izu60k",
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
      )
      .then((result) => {
        console.log(result.text);
        alert("Message envoyé !");
      })
      .catch((error) => {
        console.log(error.text);
        alert("Erreur lors de l'envoi !");
      });

    e.target.reset(); // Optionnel : vide le formulaire après envoi
  };

  return (
    <div>
      <Helmet>
        <title>Contactez LM Couleurs – Peintre à Vannes (56)</title>
        <meta
          name="description"
          content="Besoin d’un devis ou d’un conseil ? Contactez LM Couleurs, peintre professionnel à Vannes. Réponse rapide, déplacement dans tout le Morbihan."
        />
        <link rel="canonical" href="https://lmcouleurs.fr" />
        <meta
          property="og:title"
          content="Contactez LM Couleurs – Peintre à Vannes"
        />
        <meta
          property="og:description"
          content="Demandez un devis personnalisé ou un rendez-vous avec LM Couleurs, peintre professionnel à Vannes et alentours."
        />
        <meta property="og:url" content="https://lmcouleurs.fr/contact" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://lmcouleurs.fr/images/og-contact.jpg"
        />
      </Helmet>

      <Navbar />
      <div className="contact">
        <h1>Contact</h1>
        <div className="contact-card">
          <div className="contact-card-left">
            <h2>Besoin de conseils ou d'un devis personalisé ?</h2>
            <form ref={form} onSubmit={sendEmail}>
              <ul>
                <li>
                  <label htmlFor="name"></label>
                  <input
                    type="text"
                    placeholder="Nom *"
                    id="name"
                    name="name"
                    required
                  />
                </li>
                <li>
                  <label htmlFor="firstname"></label>
                  <input
                    type="text"
                    placeholder="Prénom *"
                    id="firstname"
                    name="firstname"
                    required
                  />
                </li>
                <li>
                  <label htmlFor="email"></label>
                  <input
                    type="email"
                    placeholder="Email *"
                    id="email"
                    name="email"
                    required
                  />
                </li>
                <li>
                  <label htmlFor="telephone"></label>
                  <input
                    type="tel"
                    placeholder="Téléphone"
                    id="telephone"
                    name="telephone"
                  />
                </li>
                <li>
                  <label htmlFor="message"></label>
                  <textarea
                    placeholder="Quels sont vos besoins ? *"
                    id="message"
                    name="message"
                    required
                  ></textarea>
                </li>
              </ul>
              <div className="checkbox-container">
                <input type="checkbox" id="consent" name="consent" required />
                <label htmlFor="consent">
                  J'accepte que mes données soient utilisées pour le traitement
                  de ma demande, voir la{" "}
                  <Link to="/politique-de-confidentialite">
                    politique de confidentialité
                  </Link>
                  .
                </label>
              </div>
              <button type="submit" className="btn">
                Envoyer
              </button>
            </form>
          </div>
          <div className="contact-card-image">
            <div className="contact-card-image-left">
              <h2>Devis 100% gratuit</h2>
              <p className="contact-text">
                Contactez LM Couleurs dès aujourd'hui et donnons vie à cos
                idées, une couche à la fois !
              </p>
              <p className="contact-links">
                <span role="img" aria-label="téléphone">
                  📞
                </span>{" "}
                <a href="tel:+33612345678">06 50 94 70 92</a>
              </p>
              <p className="contact-links">
                <span role="img" aria-label="email">
                  ✉️
                </span>{" "}
                <a href="mailto:contact@lmcouleurs.fr">
                  lmcouleurs56@gmail.com
                </a>
                .
              </p>
              <p className="contact-links">
                <span role="img" aria-label="localisation">
                  📍
                </span>{" "}
                Vannes & alentours
              </p>
            </div>
            {/* <img src={ContactImg} alt="Contact" /> */}
          </div>
        </div>
        <div className="footer-links">
          <div className="footer-logo">
            <Link to="/">
              <img src={Logo} alt="logo LM Couleurs" />
            </Link>
          </div>
          <div className="footer-nav-links">
            <Link to={"/"}>Accueil</Link>
            <Link to={"/services"}>Services</Link>
            <Link to={"/realisations"}>Réalisations</Link>
            <Link to={"/FAQ"}>FAQ</Link>
            <Link to={"/contact"}>Contact</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
